<script lang="ts">
    import { onMount } from 'svelte'

    import { ace_modes } from './stores/ace_modes_store'

    import Nav from './Nav.svelte'
    import Modal from './sub/Modal.svelte'
    import CodeEditor from './sub/CodeEditor.svelte'
    import HumanFileSize from './sub/HumanFileSize.svelte'
    import page from 'page'

    // ui stuff
    let modal_open   = false
    let is_uploading = false

    const MAX_FILE_SIZE = 256 * 1024

    // important
    let selected_mode = 'plain_text'
    let text = ''
    let title    = ''
    let description = ''

    onMount( () => {
        let saved = localStorage.getItem('pb_create')
        if (saved) {
            saved = JSON.parse(saved)

            selected_mode = saved['selected_mode']
            text          = saved['text']
            title         = saved['title']
            description   = saved['description']
        }
    })

    const set_mode = mode => {
        console.log(`setting mode ${mode}`)
        selected_mode = mode
    }

    const cache_inputs = () => {
        localStorage.setItem(
            'pb_create',
            JSON.stringify({
                selected_mode,
                text,
                title,
                description
            })
        )
    }

    const submit_form = async e => {
        e.preventDefault()
        if (text.length > MAX_FILE_SIZE) {
            return
        }

        is_uploading = true
        console.log(selected_mode, text, title, description)

        let resp = await window.pb.paste_create(
            title,
            description,
            text,
            selected_mode
        )

        if (resp) {
            localStorage.removeItem('pb_create')
            page(`/view/${resp.replace('paste_', '')}`)
        }
    }

</script>

<style>
    .fullpage_editor {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start;

        height: 100vh;
    }

    .fullpage_editor__editblock {
        flex-grow: 1;
    }

    .fullpage_editor__tools {
        padding: 1em 2em 1em 2em;
    }
</style>


<div class="fullpage_editor">
    <Nav/>

    <div class="fullpage_editor__editblock">
        <CodeEditor
            on:input={cache_inputs}
            bind:text={text}
            bind:mode={selected_mode}/>
    </div>

    <div class="fullpage_editor__tools level">
        <div class="level-left">
            <div class="dropdown is-up is-hoverable">
                <div class="dropdown-trigger">
                    <button class="button is-small">
                        <span>Language: {selected_mode}</span>
                        <span class="icon is-small">
                            <i class="fas fa-angle-up" aria-hidden="true"></i>
                        </span>
                    </button>
                </div>
                <div class="dropdown-menu" role="menu">
                    <div class="dropdown-content">
                        {#each $ace_modes as mode}
                            <a class="dropdown-item" href="#" on:click={() => set_mode(mode)}>
                                {mode}
                            </a>
                        {/each}
                    </div>
                </div>
            </div>
        </div>
        <div class="level-right">
            <button type="button" class="button is-small" on:click={() => modal_open = true}>
                <span>Next</span>
                <span class="icon">
                    <i class="fas fa-arrow-right"></i>
                </span>
            </button>
        </div>
        
    </div>
</div>

<Modal bind:open={modal_open}>
    <div class="box">
        <form on:submit={submit_form}>
            <div class="field">
                <label class="label" for="title">Title<span class="has-text-danger">*</span></label>
                <div class="control">
                    <input
                            class="input"
                            id="title"
                            type="text"
                            name=""
                            bind:value={title}
                            required
                            autocomplete="off"
                            autocapitalize="off"
                            placeholder="untitled.txt">
                </div>
            </div>
            <div class="field block">
                <label class="label" for="description">Description</label>
                <div class="control">
                    <input
                            class="input"
                            id="description"
                            type="text"
                            name=""
                            bind:value={description}
                            autocomplete="off"
                            autocapitalize="off"
                            placeholder="hello untitled">
                </div>
            </div>

            <div class="level block">
                <div class="level-left">
                    <div>
                        File size: <HumanFileSize bytes={text.length}></HumanFileSize>
                        <br>
                        File type: {selected_mode}
                    </div>
                </div>

                
                    <div class="level-right">
                    {#if text.length <= MAX_FILE_SIZE}
                        <button 
                             disabled={is_uploading}
                            type="submit"
                            class="button is-primary {is_uploading ? 'is-loading' : ''}">
                            <span>Upload</span>
                            <span class="icon">
                                <i class="fas fa-arrow-right"></i>
                            </span>
                        </button>
                    {:else}
                        <button 
                            disabled
                            type="submit"
                            class="button is-danger">
                            <span class="icon">
                                <i class="fas fa-exclamation-triangle"></i>
                            </span>
                            <span>Too big!</span>
                        </button>
                    {/if}
                    </div>
            </div>
        </form>
    </div>
    
</Modal>

